/* Cart drawer upsells (zuckerfeather custom).
 * When the drawer opens, recommends products related to the first cart item
 * via Shopify's native recommendations API; one-click add refreshes the drawer.
 */
(function () {
  var loadedFor = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshDrawer() {
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var drawer = document.querySelector('cart-drawer');
        var inner = drawer && drawer.querySelector('.drawer__inner');
        var freshInner = html.querySelector('.drawer__inner');
        if (inner && freshInner) inner.innerHTML = freshInner.innerHTML;
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          fetch(window.location.pathname + '?section_id=cart-icon-bubble')
            .then(function (r) { return r.text(); })
            .then(function (t) {
              var fresh = new DOMParser().parseFromString(t, 'text/html').querySelector('.shopify-section');
              if (fresh) bubble.innerHTML = fresh.innerHTML;
            });
        }
        loadedFor = null;
        loadUpsells();
      });
  }

  function loadUpsells() {
    var box = document.querySelector('cart-drawer .cart-upsells');
    if (!box) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) { box.hidden = true; return; }
        var pid = cart.items[0].product_id;
        var list0 = box.querySelector('.cart-upsells__list');
        if (loadedFor === pid && list0.children.length) { box.hidden = false; return; }
        var inCart = cart.items.map(function (i) { return i.product_id; });
        fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (data) {
            var recs = (data.products || [])
              .filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available; })
              .slice(0, 3);
            var list = box.querySelector('.cart-upsells__list');
            list.innerHTML = '';
            if (!recs.length) { box.hidden = true; return; }
            recs.forEach(function (p) {
              var v = p.variants && p.variants[0];
              if (!v) return;
              var img = p.featured_image
                ? p.featured_image + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=120'
                : '';
              var li = document.createElement('li');
              li.className = 'cart-upsells__item';
              li.innerHTML =
                '<a class="cart-upsells__media" href="' + p.url + '">' +
                  (img ? '<img src="' + img + '" alt="" width="56" height="56" loading="lazy">' : '') +
                '</a>' +
                '<div class="cart-upsells__info">' +
                  '<a class="cart-upsells__title" href="' + p.url + '"></a>' +
                  '<span class="cart-upsells__price">' + money(v.price) + '</span>' +
                '</div>' +
                '<button type="button" class="button button--secondary cart-upsells__add">Add</button>';
              li.querySelector('.cart-upsells__title').textContent = p.title;
              li.querySelector('.cart-upsells__add').addEventListener('click', function () {
                this.disabled = true;
                this.textContent = '…';
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
                }).then(refreshDrawer);
              });
              list.appendChild(li);
            });
            loadedFor = pid;
            box.hidden = false;
          });
      });
  }

  // load when the drawer opens (Dawn toggles the 'active' class / animate)
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  new MutationObserver(function () {
    if (drawer.classList.contains('active') || drawer.classList.contains('animate')) loadUpsells();
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('DOMContentLoaded', loadUpsells);
})();
